import { ofType, Epic } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { AjaxResponse, AjaxError } from 'rxjs/ajax';
import { get } from '__utils/ajax-wrapper';
import { FluxStandardAction } from '__utils/type';
import { ENDPOINTS } from 'constants/endpoints';
import * as Actions from 'constants/actions';
import * as bankDetailsActions from './bank-details.actions';
import resolveURLParams from '__utils/url-params-resolver';

export const getCheckIfscEpic: Epic<FluxStandardAction, FluxStandardAction> = action$ => {
    return action$.pipe(
        ofType(Actions.FETCH_GET_CHECK_IFSC),
        mergeMap((action) => {
            return get(resolveURLParams(ENDPOINTS.GET_CHECK_IFSC, action.payload, null), {}, true).pipe(
                map((response: AjaxResponse | AjaxError): FluxStandardAction => {
                    if (response.status === 200) {
                        return bankDetailsActions.searchIfscSuccess(response.response.content);
                    }
                    else {
                        return bankDetailsActions.searchIfscError(response.response);
                    }
                }),
                catchError(error => of(bankDetailsActions.searchIfscError(error)))
            );
        })
    );
};
